<template>
  <div class="logout-button" @click="$emit('click')">
    <div class="logout-button__icon">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.56055 6.7504H8.25C8.44891 6.7504 8.63968 6.67139 8.78033 6.53073C8.92098 6.39008 9 6.19932 9 6.0004C9 5.80149 8.92098 5.61073 8.78033 5.47007C8.63968 5.32942 8.44891 5.2504 8.25 5.2504H2.56055L3.53027 4.28068C3.67027 4.13991 3.74872 3.94937 3.74845 3.75084C3.74817 3.5523 3.66918 3.36198 3.5288 3.2216C3.38842 3.08122 3.1981 3.00223 2.99957 3.00195C2.80104 3.00168 2.6105 3.08014 2.46972 3.22013L0.219724 5.47013C0.150065 5.53975 0.0948066 5.62242 0.0571057 5.71341C0.0194048 5.80439 0 5.90192 0 6.0004C0 6.09889 0.0194048 6.19641 0.0571057 6.2874C0.0948066 6.37839 0.150065 6.46105 0.219724 6.53068L2.46972 8.78068C2.53929 8.85064 2.62198 8.90618 2.71305 8.94412C2.80411 8.98206 2.90177 9.00167 3.00043 9.0018C3.09909 9.00194 3.1968 8.98261 3.28798 8.94492C3.37915 8.90723 3.46199 8.85192 3.53175 8.78216C3.60151 8.7124 3.65682 8.62956 3.69451 8.53838C3.73221 8.44721 3.75154 8.34949 3.7514 8.25084C3.75126 8.15218 3.73166 8.05452 3.69371 7.96345C3.65577 7.87238 3.60023 7.7897 3.53027 7.72013L2.56055 6.7504Z"
          fill="#F44040"
        />
        <path
          d="M11.25 1.20564e-07H5.25C5.15149 -5.57476e-05 5.05394 0.0193054 4.96292 0.0569767C4.8719 0.0946479 4.7892 0.14989 4.71955 0.219545C4.64989 0.289201 4.59465 0.371902 4.55698 0.462922C4.51931 0.553941 4.49994 0.651493 4.5 0.75V2.25C4.5 2.44891 4.57902 2.63968 4.71967 2.78033C4.86032 2.92098 5.05109 3 5.25 3C5.44891 3 5.63968 2.92098 5.78033 2.78033C5.92098 2.63968 6 2.44891 6 2.25V1.5H10.5V10.5H6V9.75C6 9.55109 5.92098 9.36032 5.78033 9.21967C5.63968 9.07902 5.44891 9 5.25 9C5.05109 9 4.86032 9.07902 4.71967 9.21967C4.57902 9.36032 4.5 9.55109 4.5 9.75V11.25C4.49994 11.3485 4.51931 11.4461 4.55698 11.5371C4.59465 11.6281 4.64989 11.7108 4.71955 11.7805C4.7892 11.8501 4.8719 11.9054 4.96292 11.943C5.05394 11.9807 5.15149 12.0001 5.25 12H11.25C11.3485 12.0001 11.4461 11.9807 11.5371 11.943C11.6281 11.9054 11.7108 11.8501 11.7805 11.7805C11.8501 11.7108 11.9054 11.6281 11.943 11.5371C11.9807 11.4461 12.0001 11.3485 12 11.25V0.75C12.0001 0.651493 11.9807 0.553941 11.943 0.462922C11.9054 0.371902 11.8501 0.289201 11.7805 0.219545C11.7108 0.14989 11.6281 0.0946479 11.5371 0.0569767C11.4461 0.0193054 11.3485 -5.57476e-05 11.25 1.20564e-07Z"
          fill="#F44040"
        />
      </svg>
    </div>
    <div class="logout-button__text">
      {{ $t('auth.logout-user.base.logout') }}
    </div>
  </div>
</template>

<script>
export default { name: 'LogoutButton', emits: ['click'] }
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.logout-button {
  display: flex;
  align-items: center;
  transition: opacity 0.2s linear;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    width: 12px;
    height: 12px;
    margin-right: 8px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    color: $cancel;
    font-weight: 600;
    font-size: pxToRem(12);
    line-height: pxToRem(15);
  }
}
</style>
